import { UpdateUserRequest } from "../../../@types/Users";
import { api } from "../../api";

export default async function update(dto: UpdateUserRequest) {
  try {
    const { data } = await api.put("/user", {
      userName: dto.userName,
      profilePicture: dto.profilePicture,
      investorType: dto.investorType,
      newPassword: dto.newPassword,
      confirmNewPassword: dto.confirmNewPassword,
      oldPassword: dto.oldPassword,
    });

    return data;
  } catch (err) {
    console.log(err);

    return null;
  }
}
